import { store } from "../../app/store";
import { updateMessage, updateSignClick } from "./LoginBoxSlice";

export const dispatchSignMessage = async (message) => {
    store.dispatch(updateMessage(message));
    store.dispatch(updateSignClick(true));
}